const card = {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // 会员查询套餐卡详情
    async queryCardDetail({ rootState, commit }, params = {}) {
      const data = await rootState.http("/member/getCardDetail", params);
      return data;
    }
  }
};

export default card;



// WEBPACK FOOTER //
// ./src/store/modules/card.js